var _g;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgPhone = function SvgPhone(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    "aria-describedby": descId,
    viewBox: "0 0 40 40",
    role: "img",
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phone icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, desc === undefined ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, "phone icon") : desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m38.95 30.859-8.096-5.4a2.363 2.363 0 0 0-3.164.514l-2.358 3.032c-.303.4-.854.516-1.293.272l-.448-.247c-1.487-.81-3.338-1.82-7.066-5.55s-4.74-5.581-5.55-7.066l-.246-.448a1.01 1.01 0 0 1 .267-1.297l3.03-2.358a2.365 2.365 0 0 0 .515-3.165L9.14 1.05A2.35 2.35 0 0 0 5.973.336L2.587 2.37A4.78 4.78 0 0 0 .41 5.197C-.81 9.639.107 17.306 11.4 28.6 20.384 37.584 27.072 40 31.668 40a11.8 11.8 0 0 0 3.133-.41 4.77 4.77 0 0 0 2.826-2.177l2.036-3.384a2.35 2.35 0 0 0-.713-3.17Zm-.436 2.486-2.03 3.386a3.45 3.45 0 0 1-2.034 1.576c-4.1 1.126-11.265.193-22.106-10.65S.569 9.651 1.695 5.55a3.45 3.45 0 0 1 1.578-2.036l3.386-2.03a1.02 1.02 0 0 1 1.375.309l2.933 4.403 2.461 3.692a1.026 1.026 0 0 1-.222 1.374l-3.031 2.358a2.33 2.33 0 0 0-.618 2.994l.24.437c.852 1.563 1.912 3.507 5.778 7.373 3.867 3.866 5.81 4.926 7.372 5.778l.438.24a2.33 2.33 0 0 0 2.994-.617l2.358-3.031c.33-.42.927-.517 1.373-.223l8.095 5.4c.455.301.591.908.31 1.375ZM22.65 6.3c6.1.007 11.043 4.95 11.05 11.05a.65.65 0 1 0 1.3 0C34.992 10.532 29.468 5.007 22.65 5a.65.65 0 1 0 0 1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.714 11.429a7.866 7.866 0 0 1 7.857 7.857.714.714 0 0 0 1.429 0A9.296 9.296 0 0 0 22.714 10a.714.714 0 1 0 0 1.429Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.625 15.25a3.13 3.13 0 0 1 3.125 3.125.625.625 0 0 0 1.25 0A4.38 4.38 0 0 0 22.625 14a.625.625 0 1 0 0 1.25Z"
  }))));
};
export default SvgPhone;